<div class="container-fluid" [@fadeInAnimation]>
  <div class="row">
    <div class="col-lg-2"></div>
    <div class="col-lg-8">
      <div class="jumbotron">
        <div class="garanti-xl-logo text-center">
          <img [src]="logoSource" />
        </div>
        <div class="frontpage-text lead">
          <span [innerHTML]="(isBorgenarMode ? borgenarTextKey : textKey) | translate | safehtml"></span>
        </div>
      </div>
    </div>
  </div>
</div>
